/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { useState, useEffect } from 'react';
import CheerioButton from '../../Components/CheerioButton.jsx';
import images from '../../Utils/images';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import { FiEdit2 } from 'react-icons/fi';
import { BsTrash } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { getAIAssistantList, deleteAIAgent } from './actions';
import { eventsend } from '../../Config/analyticsFunctions.js';
import { useSelector } from 'react-redux';
import { styledSx } from '../ContactModule/Tags/variableDependencies.js';
import { toast } from 'react-toastify'
import colors from '../../Utils/colors';
import SpinnerLoader from '../../Components/SpinnerLoader.jsx'


export default function AIAssistantList() {
    const [agents, setAgents] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [deleteModal, setDeleteModal] = useState<{ open: boolean; id: string | null; name: string | null }>({ open: false, id: null, name: null });
    const [deleteInput, setDeleteInput] = useState('');
    const navigate = useNavigate();

    const authtoken = useSelector((state: any) => state.main.auth_token);
    const localdata = useSelector((state: any) => state.main.localdata);

    useEffect(() => {
        setLoading(true);
        setError(null);
        getAIAssistantList(authtoken)
            .then(res => {
                // Map API response to DataGrid rows
                const rows = (res?.data?.data || []).map((item: any) => ({
                    id: item._id,
                    name: item.name,
                    tokens: item.tokens || '-', // You may want to calculate tokens used if available
                    model: item.ai_model || item.model || '-',
                    created: item.createdAt ? new Date(item.createdAt).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '-',
                    updated: item.updatedAt ? new Date(item.updatedAt).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '-',
                    raw: item,
                }));
                console.log("rows", rows)
                setAgents(rows);
            })
            .catch(err => {
                setError('Failed to fetch AI assistants.');
            })
            .finally(() => setLoading(false));
    }, []);

    // Columns for the MUI DataGrid


    const columns: GridColDef[] = [
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            filterable: false,
            renderCell: (params: any) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Tooltip title="Edit">
                            <div
                                onClick={() => {
                                    eventsend('edit_saved_assistant_clicked', {
                                        assistant_id: params.row.id,
                                        assistant_name: params.row.name
                                    });
                                    navigate(`/creator/ai-assistants/edit/${params.row.id}`);
                                }}
                                style={{ color: '#A259FF', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                            >
                                <FiEdit2 />
                            </div>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <div
                                onClick={() => {
                                    setDeleteModal({ open: true, id: params.row.id, name: params.row.name });
                                }}
                                style={{ color: '#A259FF', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                            >
                                <BsTrash />
                            </div>
                        </Tooltip>
                    </div>
                );
            },
        },
        { field: 'name', headerName: 'Assistant Name', flex: 1, align: 'center', headerAlign: 'center' },
        {
            field: 'tokens',
            headerName: 'Token used',
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params: any) => (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <a
                        href={`/creator/ai-assistants/${params.row.id}/token-usage`}
                        onClick={(e) => {
                            e.preventDefault();
                            navigate(`/creator/ai-assistants/${params.row.id}/token-usage`);
                        }}
                        style={{ color: '#A259FF', fontSize: '14px', textDecoration: 'underline' }}
                    >
                        Check Usage
                    </a>
                </div>
            )
        },
        { field: 'model', headerName: 'Model', flex: 1, align: 'center', headerAlign: 'center' },
        { field: 'created', headerName: 'Created On', flex: 1, align: 'center', headerAlign: 'center' },
        { field: 'updated', headerName: 'Updated On', flex: 1, align: 'center', headerAlign: 'center' },
    ];

    return (
        <>

            {loading ? (
                <div
                    className="d-flex flex-column justify-content-center align-items-center w-100"
                    style={{ flex: 1 }}
                >
                    <SpinnerLoader />
                </div>
            ) : (
                <div
                    style={{
                        padding: '24px 16px',
                        background: '#fcfcfc',
                        minHeight: '100vh',
                        width: '100%',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16,
                            padding: '0 16px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 8,
                                width: '100%',
                            }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                                <div style={{ fontWeight: 600, fontSize: 24 }}>AI Assistants</div>
                                <div style={{ alignSelf: 'flex-end' }}>
                                    <CheerioButton
                                        btnText="Create Assistant"
                                        backColor="#373FCC"
                                        textStyle={{ color: 'white', fontWeight: 500 }}
                                        onclick={() => {
                                            eventsend("create_assistant_button_clicked");
                                            navigate('/creator/ai-assistants/create');
                                        }}
                                        borderStyle={{
                                            borderRadius: '10px',
                                            border: '1px solid #373FCC',
                                        }}
                                        icon={null}
                                        id="create-assistant-btn"
                                    />
                                </div>
                            </div>
                            <div style={{ fontSize: 16, color: '#444', fontWeight: 400 }}>
                                Create and deploy an AI-powered assistant on your WhatsApp Business Account for your customers to respond to their queries automatically.
                            </div>

                        </div>

                        {
                            agents?.length > 0 && localdata?.walletCurrency != "" ? (
                                <div style={{ overflowX: 'auto', width: '100%' }}>
                                    <div style={{ minWidth: 700 }}>
                                        <DataGrid
                                            rows={agents}
                                            columns={columns}
                                            pagination
                                            paginationModel={{ pageSize: 10, page: 0 }}
                                            pageSizeOptions={[5, 10, 20]}
                                            disableRowSelectionOnClick
                                            autoHeight
                                            sx={styledSx}
                                        />
                                    </div>
                                </div>
                            ) : agents.length === 0 && localdata?.walletCurrency != "" ? (
                                <div style={{
                                    textAlign: 'center', padding: '24px 16px', marginTop: '10%'
                                }}>
                                    < img src={images.NoAiAssistant} alt="Empty State" />
                                    <div style={{ fontSize: 16, color: '#444', fontWeight: 400, width: '50%', margin: '0 auto', padding: '16px' }}>
                                        Create and deploy an AI-powered assistant on your WhatsApp Business account to automatically respond to your customers’ queries.
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
                                        <CheerioButton
                                            btnText="Create Assistant"
                                            backColor="#373FCC"
                                            textStyle={{ color: 'white', fontWeight: 500 }}
                                            onclick={() => {
                                                eventsend("create_assistant_button_clicked");
                                                navigate('/creator/ai-assistants/create');
                                            }}
                                            borderStyle={{
                                                borderRadius: '10px',
                                                border: '1px solid #373FCC',
                                            }}
                                            icon={null}
                                            id="create-assistant-btn"
                                        />
                                        <CheerioButton
                                            btnText="Learn More"
                                            backColor="#fff"
                                            textStyle={{ color: '#373FCC', fontWeight: 500 }}
                                            onclick={() => {
                                                window.open('https://www.cheerio.in/post/how-do-you-create-and-deploy-an-ai-assistant-on-whatsapp-or-instagram', '_blank');
                                            }}
                                            borderStyle={{
                                                borderRadius: '10px',
                                                color: '#373FCC',
                                                border: '1px solid #373FCC',
                                            }}
                                            icon={null}
                                            id="import-assistant-btn"
                                        />
                                    </div>
                                    {/* <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '16px' }}>
                                    <img src={images.Video} alt="Video Guide" style={{ width: '24px', height: '24px' }} />
                                    <a href="https://www.cheerio.in/post/how-do-you-create-and-deploy-an-ai-assistant-on-whatsapp-or-instagrams" target="_blank" rel="noopener noreferrer" style={{ color: '#A259FF', fontWeight: 500, textDecoration: 'underline' }}>
                                        Watch Video Guide
                                    </a>
                                </div> */}
                                </div>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '24px 120px', marginTop: '10%' }}>
                                    <h3 className='mb-2 p-18'>Your account is Credit Based, Please switch to Wallet Based Billing to use AI Assistant, Contact Support at support@cheerio.in for more details</h3>

                                </div>
                            )
                        }
                    </div>
                </div >
            )}

            {/* Delete Modal */}
            {
                deleteModal.open && (
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            background: 'rgba(0,0,0,0.3)',
                            zIndex: 9999,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 16,
                        }}
                    >
                        <div
                            style={{
                                background: '#fff',
                                borderRadius: 8,
                                padding: 24,
                                width: '100%',
                                maxWidth: 400,
                                boxShadow: '0 2px 16px rgba(0,0,0,0.15)',
                            }}
                        >
                            <h3 style={{ margin: 0, marginBottom: 12 }}>Delete Assistant</h3>
                            <p style={{ margin: 0, marginBottom: 12 }}>
                                Type <b>delete</b> to confirm deletion of <b>{deleteModal.name}</b>.
                            </p>
                            <input
                                type="text"
                                value={deleteInput}
                                onChange={e => setDeleteInput(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: 8,
                                    marginBottom: 16,
                                    border: '1px solid #ccc',
                                    borderRadius: 4,
                                }}
                                autoFocus
                            />
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }}>
                                <button
                                    onClick={() => {
                                        setDeleteModal({ open: false, id: null, name: null });
                                        setDeleteInput('');
                                    }}
                                    style={{
                                        padding: '6px 18px',
                                        borderRadius: 4,
                                        border: 'none',
                                        background: '#eee',
                                        fontWeight: 600,
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={async () => {
                                        if (deleteInput !== 'delete' || !deleteModal.id) return;
                                        try {
                                            await deleteAIAgent(deleteModal.id, authtoken);
                                            eventsend('assistant_deleted', {
                                                assistant_id: deleteModal.id,
                                                assistant_name: deleteModal.name
                                            });
                                            setAgents(prev => prev.filter(a => a.id !== deleteModal.id));
                                            toast.success('Assistant deleted', { position: 'top-center' });
                                        } catch (err) {
                                            toast.error('Failed to delete', { position: 'top-center' });
                                        } finally {
                                            setDeleteModal({ open: false, id: null, name: null });
                                            setDeleteInput('');
                                        }
                                    }}
                                    disabled={deleteInput !== 'delete'}
                                    style={{
                                        padding: '6px 18px',
                                        borderRadius: 4,
                                        border: 'none',
                                        background: deleteInput === 'delete' ? '#E50000' : '#eee',
                                        color: deleteInput === 'delete' ? '#fff' : '#888',
                                        fontWeight: 600,
                                    }}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }

        </>
    );

}
